import React from 'react';
import { Box, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import CookieSnackbar from './landing-page/CookieSnackbar';
import LandingCtaBanner from './landing-page/LandingCtaBanner';
import LandingFaqSection from './landing-page/LandingFaqSection';
import LandingFeaturesSection from './landing-page/LandingFeaturesSection';
import LandingFooter from './landing-page/LandingFooter';
import LandingHero from './landing-page/LandingHero';
import LandingPricingSection from './landing-page/LandingPricingSection';
import LandingTestimonialsSection from './landing-page/LandingTestimonialsSection';
import useLandingPageState from './landing-page/useLandingPageState';

export default function LandingPage() {
    const navigate = useNavigate();
    const {
        showInclVat,
        billingCycle,
        cookieOpen,
        vatLabel,
        invoiceNetMonthly,
        accountingNetMonthly,
        invoiceFeatures,
        isYearly,
        setShowInclVat,
        setBillingCycle,
        handleAcceptCookies,
    } = useLandingPageState();

    const handleStart = () => navigate('/registration');

    return (
        <Box sx={{ bgcolor: 'background.default', color: 'text.primary' }}>
            <LandingHero onStart={handleStart} />

            <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
                <LandingFeaturesSection />
            </Container>

            <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
                <LandingPricingSection
                    invoiceNetMonthly={invoiceNetMonthly}
                    accountingNetMonthly={accountingNetMonthly}
                    showInclVat={showInclVat}
                    billingCycle={billingCycle}
                    isYearly={isYearly}
                    vatLabel={vatLabel}
                    invoiceFeatures={invoiceFeatures}
                    onStart={handleStart}
                    onToggleVat={setShowInclVat}
                    onBillingCycleChange={setBillingCycle}
                />
            </Container>

            <Container maxWidth="md" sx={{ py: { xs: 6, md: 8 } }}>
                <LandingTestimonialsSection />
            </Container>

            <Container maxWidth="md" sx={{ py: { xs: 6, md: 8 } }}>
                <LandingFaqSection />
            </Container>

            <Container maxWidth="lg" sx={{ pb: { xs: 6, md: 8 } }}>
                <LandingCtaBanner onStart={handleStart} />
            </Container>

            <Container maxWidth="lg" sx={{ pb: 6 }}>
                <LandingFooter />
            </Container>

            <CookieSnackbar open={cookieOpen} onAccept={handleAcceptCookies} />
        </Box>
    );
}
